import {createContext} from 'react'

export const ProjectDetailsContext = createContext({
  projectId: null as any,
  projectName: '',
  projectStatus: '',
  projectDetails: {} as any,
  projectMappingDetails: {} as any,
  hasProjectPermission: false,
  isLoading: false,
})

export const AgileBoardPageContext = createContext({
  hasBoardPermission: false,

  projectId: null as any,
  projectName: '',
  projectStatus: '',

  agileBoardStructure: [],
  isLoadingBoardStructure: false,

  agileBoardData: [],
  filtersData: [],
  refetchAgileBoardData: () => {},
  isLoadingAgileBoardData: false,
  onSearch: (e: string) => {},

  projectMembers: [],
  isLoadingProjectMembers: false,

  projectKanbanStages: [],
  isLoadingProjectKanbanStages: false,

  projectModules: [],
  isLoadingProjectModules: false,

  projectStatuses: [],
  isLoadingProjectStatuses: false,

  projectPriorities: [],
  isLoadingProjectPriorities: false,

  createTicket: (moduleId: string, data: any, setError: Function) => {},
  updateTicket: (data: any, ticketId: number, dirtyFields: any, setError: Function) => {},
  isLoadingTicketOperation: false,

  updateAgileBoard: (updatedTaskDetails: any, taskId: string) => {},
  isUpdatingAgileBoard: false,
})

export const ListViewPageContext = createContext({
  hasListViewPermission: false,

  projectId: null as any,
  projectName: '',
  projectStatus: '',

  checkedRows: [] as any[],
  setCheckedRows: (rows: any[]) => {},

  agileBoardTicketList: [],
  isLoadingAgileBoardTicketList: false,
  filters: {},
  onSearch: (e: string) => {},
  onPageChange: (page: number) => {},
  onSortingChange: (sortBy: string, sortDirection: any) => {},
  filtersData: [],
  refetchAgileBoardTicketList: () => {},
  agileBoardTicketMeta: {},

  isLoadingAgileBoardData: false,

  projectMembers: [],
  isLoadingProjectMembers: false,

  projectKanbanStages: [],
  isLoadingProjectKanbanStages: false,

  projectModules: [],
  isLoadingProjectModules: false,

  projectStatuses: [],
  isLoadingProjectStatuses: false,

  projectPriorities: [],
  isLoadingProjectPriorities: false,

  createTicket: (moduleId: string, data: any, setError: Function) => {},
  updateTicket: (data: any, ticketId: number, dirtyFields: any, setError: Function) => {},
  deleteTicket: (payload: any, setCheckedRows: Function) => {},
  isLoadingTicketOperation: false,
})

export const ProjectMembersPageContext = createContext({
  hasMembersPermission: false,

  projectId: null as any,
  projectName: '',
  projectStatus: '',

  projectMembersList: [],
  isLoadingProjectMembersList: false,
  filters: {},
  onSearch: (e: string) => {},
  onSortingChange: (sortBy: string) => {},

  membersList: [],
  isLoadingMembersList: false,

  addProjectMembers: (memberDetails: any) => {},
  addProjectTeams: (teamIds: any) => {},
  removeProjectMember: (memberID: number) => {},
  transferProjectOwnership: (payload: any) => {},
  isLoadingOperation: false,

  projectMembersDropdownList: [],
  isLoadingProjectMembersDropdownList: false,

  isLoadingProjectsTeamsList: false,
  ProjectsTeamsList: [],
})

export const GanttChartPageContext = createContext({
  hasGanttChartPermission: false,

  ganttChartData: [] as any,
  filtersData: [],
  isLoadingGanttChartData: false,
  onSearchGanttChartData: (searchValue: string) => {},
  refetchGanttChartData: () => {},

  chartView: 'month',
  setChartView: (view: string) => {},

  chartState: {} as any,
  setChartState: (data: any) => {},

  updateGanttChart: (payload: any, ticketId: number) => {},
  sortGanttChartRows: (payload: any) => {},
  isLoadingOperation: false,
})

export const BoardSettingsPageContext = createContext({
  hasBoardSettingsPermission: false,

  projectId: null as any,
  projectName: '',
  projectStatus: '',

  boardColumnsList: [],
  isLoadingBoardColumnsList: false,

  columnMappingDropdownList: [] as any,
  columnMappingDropdownPagination: {} as any,
  isLoadingColumnMappingDropdownList: false,
  onSearchDropdownOptions: (e: string) => {},
  onDropdownPageChange: (page: number) => {},

  boardModulesList: [],
  isLoadingBoardModulesList: false,

  boardCustomFieldsList: [],
  isLoadingBoardCustomFieldsList: false,

  customFieldMappingDropdownList: [],
  isLoadingCustomFieldMappingDropdownList: false,

  globalCustomFieldsList: [],
  isLoadingGlobalCustomFieldsList: false,

  createColumn: (data: any, setError: Function) => {},
  updateColumn: (moduleId: string, data: any, dirtyFields?: any, setError?: Function) => {},
  updateColumnTableSorting: (columnTableRowOrder: any) => {},
  deleteColumn: (moduleId: string) => {},
  mapColumnStatus: (selectedOption: any, columnId: string, setError: Function) => {},
  columnOperationId: null,
  isLoadingColumnOperation: false,

  createModule: (data: any, setError: Function) => {},
  updateModule: (moduleId: string, data: any, dirtyFields?: any, setError?: Function) => {},
  updateModuleTableSorting: (moduleTableRowOrder: any) => {},
  deleteModule: (moduleId: string) => {},
  moduleOperationId: null,
  isLoadingModulesOperation: false,

  createCustomField: (customFieldDetails: any, setError: Function) => {},
  updateCustomField: (
    cFieldId: string,
    customFieldDetails: any,
    dirtyFields?: any,
    setError?: Function
  ) => {},
  updateCustomFieldTableSorting: (customFieldsTableRowOrder: any) => {},
  deleteCustomField: (cFieldId: string) => {},
  mapCustomFieldStatus: (selectedOption: any, cFieldId: string, setError: Function) => {},
  customFieldOperationId: null,
  isLoadingCustomFieldOperation: false,

  projectTablesDropdownList: [],
  isLoadingProjectTablesDropdownList: false,

  tableColumnsDropdownList: [],
  isLoadingTableColumnsDropdownList: false,

  projectMembers: [],
  isLoadingProjectMembers: false,

  updateProjectMapping: (payload: any) => {},
  isLoadingProjectMappingOperations: false,
})

export const TasksReportPageContext = createContext({
  hasProjectSettingsPermission: false,
  tasksReportsData: [] as any,
  filtersData: [],
  isLoading: false,
  onSortingChange: (key: string, value: string) => {},
  onProjectChange: (id: any) => {},
  onSearch: (e: string) => {},
  filters: {},
  searchValue: '',
  refetch: () => {},
})

export const MembersReportPageContext = createContext({
  hasProjectSettingsPermission: false,
  membersReportData: [] as any,
  filtersData: [],
  isLoading: false,
  onSortingChange: (key: string, value: string) => {},
  onProjectChange: (id: any) => {},
  onSearch: (e: string) => {},
  filters: {},
  searchValue: '',
  refetch: () => {},
})

export const TimeSheetReportPageContext = createContext({
  filtersData: [],
  hasProjectSettingsPermission: false,
  timeSheetData: [] as any,
  timeSheetMeta: {},
  isLoadingTimeSheetData: false,
  onSortingChange: (key: string, value: string) => {},
  onSearch: (e: string) => {},
  onProjectChange: (id: any) => {},
  filters: {},
  searchValue: '',
  onDateChange: (startDate: any, endDate: any) => {},
  refetch: () => {},
})

export const MatrixReportPageContext = createContext({
  hasProjectSettingsPermission: false,
  xAxisMatrixData: [] as any,
  yAxisMatrixData: [] as any,
  isLoadingMatrixData: false,
  onSortingChange: (key: string, value: string) => {},
  onSearch: (e: string) => {},
  filters: {},
  searchValue: '',
  onProjectChange: (id: any) => {},
  onXAxisChange: (e: any) => {},
  onYAxisChange: (e: any) => {},
  onBothChange: (valueX: any, valueY: any) => {},
})
